// extracted by mini-css-extract-plugin
module.exports = {"ProjectsDrawerItems":"ToolsDraweritems_ProjectsDrawerItems__24tDi"};